module.exports = __webpack_public_path__ + "static/img/login_form_img.2d3371d7.png";